import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { createRelevanceTestRun } from 'src/mutations/createRelevanceTestRun';
import { QUERY_KEY } from 'src/queries/queryRelevanceTestRuns';

type TestRun = Models.IngestConfigApi.RelevanceTests.RelevanceTestRun;
type CreateMutationVariables = App.RelevanceTestRuns.CreateMutationVariables;

export const useCreateRelevanceTestRun = (testDefinitionId: string): UseMutationResult<TestRun, Error, CreateMutationVariables> => {
    const queryClient = useQueryClient();

    return useMutation<TestRun, Error, CreateMutationVariables>(
        createRelevanceTestRun,
        {
            onSuccess: () => {
                queryClient.cancelQueries([QUERY_KEY]);

                queryClient.refetchQueries({
                    predicate: (query: any) => query.queryKey[0] === QUERY_KEY
                        && query.queryKey[2]?.testDefinitionId === testDefinitionId,
                });
            },
            useErrorBoundary: false,
        },
    );
};
